/* BUNDU · cro-octubre-2026 · Movimiento
   Franja en loop, aparición al bajar, línea de tiempo, cifras que cuentan y preguntas que deslizan.
   Lo que ya está en pantalla al cargar no se oculta nunca, así no afecta la carga ni el LCP. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var MARQUEE = [
    'Envío gratis a toda Colombia',
    'Paga con tarjeta, PSE o contra entrega',
    '5 días hábiles para retracto',
    'Formulado por médica funcional'
  ];

  function marquee() {
    var bars = document.querySelectorAll('.announcement-bar');
    for (var b = 0; b < bars.length; b++) {
      var bar = bars[b];
      if (bar.getAttribute('data-bm')) continue;
      bar.setAttribute('data-bm', '1');
      var track = document.createElement('div');
      track.className = 'bm-marquee__track';
      for (var g = 0; g < 2; g++) {
        var group = document.createElement('div');
        group.className = 'bm-marquee__group';
        if (g) group.setAttribute('aria-hidden', 'true');
        for (var r = 0; r < 2; r++) {
          for (var i = 0; i < MARQUEE.length; i++) {
            var item = document.createElement('span');
            item.className = 'bm-marquee__item';
            item.textContent = MARQUEE[i];
            group.appendChild(item);
          }
        }
        track.appendChild(group);
      }
      bar.textContent = '';
      bar.classList.add('bm-marquee');
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', MARQUEE.join('. '));
      bar.appendChild(track);
    }
  }

  function belowFold(el) {
    return el.getBoundingClientRect().top > window.innerHeight * 0.92;
  }

  // Revisa la posición al hacer scroll en vez de IntersectionObserver:
  // algunos navegadores pausan el observer y el contenido quedaría oculto.
  var pending = [];
  var ticking = false;

  function check() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = pending.length - 1; i >= 0; i--) {
      var item = pending[i];
      var rect = item.el.getBoundingClientRect();
      if (rect.top < vh * (1 - item.inset)) {
        pending.splice(i, 1);
        item.onIn(item.el);
      }
    }
    if (!pending.length) {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    }
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    window.setTimeout(check, 60);
  }

  function observeOnce(els, onIn, inset) {
    if (!els.length) return;
    var first = !pending.length;
    els.forEach(function (el) { pending.push({ el: el, onIn: onIn, inset: inset || 0.08 }); });
    if (first) {
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
    }
    schedule();
  }

  function reveal() {
    var list = [].slice.call(document.querySelectorAll(
      '#MainContent > .shopify-section, .bundu-results, .bundu-pdp-videos, .product__info-container > .bundu-trust-seals'
    ));
    var targets = list.filter(function (el) {
      return el.offsetHeight > 0 && belowFold(el);
    });
    targets.forEach(function (el) { el.classList.add('bm-reveal'); });
    observeOnce(targets, function (el) { el.classList.add('is-in'); });
  }

  function timeline() {
    var steps = [].slice.call(document.querySelectorAll('.bundu-steps')).filter(belowFold);
    steps.forEach(function (el) { el.classList.add('bm-draw'); });
    observeOnce(steps, function (el) { el.classList.add('is-in'); }, 0.15);
  }

  function counters() {
    var els = [].slice.call(document.querySelectorAll('[data-bm-count]'));
    observeOnce(els, function (el) {
      var end = parseFloat(el.getAttribute('data-bm-count')) || 0;
      var suffix = el.getAttribute('data-bm-suffix') || '';
      var start = null;
      var duration = end > 9 ? 1300 : 700;
      function frame(t) {
        if (start === null) start = t;
        var p = Math.min(1, (t - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(end * eased) + suffix;
        if (p < 1) window.requestAnimationFrame(frame);
      }
      el.textContent = '0' + suffix;
      window.requestAnimationFrame(frame);
    }, 0.1);
  }

  var ACC = '.bundu-faq__item, .collapsible-content details';

  function prepAccordions() {
    var items = document.querySelectorAll(ACC);
    for (var i = 0; i < items.length; i++) {
      var det = items[i];
      if (det.tagName !== 'DETAILS' || det.querySelector(':scope > .bm-acc')) continue;
      var summary = det.querySelector(':scope > summary');
      if (!summary) continue;
      var wrap = document.createElement('div');
      wrap.className = 'bm-acc';
      while (summary.nextSibling) wrap.appendChild(summary.nextSibling);
      det.appendChild(wrap);
    }
  }

  // Si el navegador congela la animación (pestaña en segundo plano), la termina igual.
  function settle(anim, ms) {
    window.setTimeout(function () {
      if (anim.playState !== 'finished') anim.finish();
    }, ms + 150);
  }

  function accordions() {
    prepAccordions();
    document.addEventListener('click', function (e) {
      var summary = e.target.closest && e.target.closest('summary');
      if (!summary) return;
      var det = summary.parentNode;
      if (!det.matches || !det.matches(ACC)) return;
      var body = det.querySelector(':scope > .bm-acc');
      if (!body || !body.animate || det.getAttribute('data-bm-busy')) return;
      e.preventDefault();
      det.setAttribute('data-bm-busy', '1');
      var done = function () { det.removeAttribute('data-bm-busy'); };
      if (det.open) {
        var from = body.offsetHeight;
        var close = body.animate(
          [{ height: from + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 220, easing: 'ease-out' }
        );
        close.onfinish = function () { det.open = false; done(); };
        settle(close, 220);
      } else {
        det.open = true;
        var to = body.offsetHeight;
        var open = body.animate(
          [{ height: '0px', opacity: 0 }, { height: to + 'px', opacity: 1 }],
          { duration: 280, easing: 'cubic-bezier(0.2, 0.65, 0.2, 1)' }
        );
        open.onfinish = done;
        settle(open, 280);
      }
    });
  }

  // Los videos de Hair: en celular van dentro de la columna del producto, antes de "Qué esperar".
  // En computador se quedan en su lugar, a todo el ancho debajo del producto.
  function placeProductVideos() {
    var sec = document.querySelector('[id$="__bundu_hair_videos"]');
    var info = document.querySelector('.product__info-container');
    if (!sec || !info || !sec.parentNode) return;
    var home = document.createComment('bundu-hair-videos');
    sec.parentNode.insertBefore(home, sec);
    var mq = window.matchMedia('(max-width: 749px)');
    function place() {
      if (mq.matches) {
        var anchor = info.querySelector(':scope > .bundu-results') ||
          info.querySelector(':scope > .product__info-as-bottom-tabs');
        if (!anchor) return;
        sec.classList.remove('bundu-pdp-videos--wide');
        sec.classList.add('bundu-pdp-videos');
        info.insertBefore(sec, anchor);
      } else {
        sec.classList.remove('bundu-pdp-videos');
        sec.classList.add('bundu-pdp-videos--wide');
        home.parentNode.insertBefore(sec, home.nextSibling);
      }
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
  }

  // Fichas de Hair, Florafix y Gutskin (las que tienen "Qué esperar" o comparativa):
  // la descripción se muestra recortada y se despliega en su mismo lugar, así hay menos scroll.
  function collapseDescription() {
    if (!document.querySelector('.bundu-results, .bcmp')) return;
    var box = document.querySelector('.product__info-container > .product__info-as-bottom-tabs');
    if (!box || box.getAttribute('data-bundu-desc')) return;
    var tall = [].slice.call(box.querySelectorAll('.dt-sc-tabs-content')).some(function (el) {
      return el.scrollHeight > 260;
    });
    if (!tall) return;
    box.setAttribute('data-bundu-desc', '1');
    box.classList.add('bundu-desc', 'is-collapsed');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bundu-desc__more';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Ver descripción completa';
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-collapsed') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Ver menos' : 'Ver descripción completa';
      if (!open) {
        var top = box.getBoundingClientRect().top + window.pageYOffset - 100;
        if (window.pageYOffset > top) window.scrollTo(0, top);
      }
    });
    box.appendChild(btn);
  }

  // Popup de Klaviyo: al cerrarlo hace una animación de salida y espera a que termine para
  // ocultarse y devolver el scroll. En algunos celulares ese fin nunca llega y el popup queda
  // transparente encima de la web con el scroll bloqueado. Si pasa, se termina el cierre aquí.
  function klaviyoScrollGuard() {
    var CLS = 'klaviyo-prevent-body-scrolling';
    var timer = null;
    var misses = 0;
    function popups() {
      return document.querySelectorAll('[role="dialog"][aria-label*="POPUP" i], [role="dialog"].needsclick');
    }
    function shown(el) {
      var cs = window.getComputedStyle(el);
      return cs.display !== 'none' && el.offsetHeight > 0 &&
        (parseFloat(cs.opacity) > 0.05 || /fadein/i.test(cs.animationName));
    }
    function stop() { clearInterval(timer); timer = null; misses = 0; }
    function check() {
      if (!document.body.classList.contains(CLS)) { stop(); return; }
      var list = popups();
      for (var i = 0; i < list.length; i++) {
        if (shown(list[i])) { misses = 0; return; }
      }
      if (++misses < 2) return;
      for (var j = 0; j < list.length; j++) {
        if (window.getComputedStyle(list[j]).display !== 'none') list[j].style.display = 'none';
      }
      document.body.classList.remove(CLS);
      stop();
    }
    function watch() {
      if (document.body.classList.contains(CLS) && !timer) timer = setInterval(check, 500);
    }
    new MutationObserver(watch).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    watch();
  }

  // Fechas de las reseñas de Judge.me: vienen como mes/día/año (formato de Estados Unidos).
  // Aquí se muestran como día/mes/año, que es como se leen en Colombia.
  function reviewDates() {
    function fix() {
      var els = document.querySelectorAll('time.jdgm-rev__timestamp[datetime]');
      for (var i = 0; i < els.length; i++) {
        var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(els[i].getAttribute('datetime') || '');
        if (!m) continue;
        var text = m[3] + '/' + m[2] + '/' + m[1];
        if (els[i].textContent !== text) els[i].textContent = text;
      }
    }
    fix();
    new MutationObserver(fix).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function start() {
    klaviyoScrollGuard();
    reviewDates();
    placeProductVideos();
    collapseDescription();
    marquee();
    if (reduce) return;
    accordions();
    reveal();
    timeline();
    counters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
